<template>
    <page-title
        title="注文詳細"
        icon="bi-card-text"
        :backTo="{ name: 'PageOrderList' }"
    >
    </page-title>

    <inline-loader v-if="loading"></inline-loader>

    <div v-else class="mb-3">
        <div class="mb-3">
            <badge-year :year="order.year"></badge-year>
            <badge-app :app_id="order.app.app_id" :app_name="order.app.app_name"></badge-app>
            <badge-order-status-for-distributor :status_id="order.order_status"></badge-order-status-for-distributor>
        </div>

        <summary-box title="注文内容">
            <summary-box-row title="" :text="order.school.school_name + '（' + order.school.full_address + '）'"></summary-box-row>
            <summary-box-row title="日時" :text="$helper.ymdhi(order.order_datetime)" optional_title_class="col-5 col-md-3"></summary-box-row>
            <summary-box-row title="備考" :text="order.note" optional_title_class="col-5 col-md-3"></summary-box-row>
        </summary-box>

        <table-normal class="mb-3" v-if="order.details.length">
            <colgroup>
                <col class="col-md-4">
                <col class="col-md-4">
                <col class="col-md-4">
            </colgroup>
            <thead>
                <tr>
                    <th scope="col">学年</th>
                    <th scope="col">クラス</th>
                    <th scope="col">注文人数</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(detail) in order.details" :key="detail.order_detail_id">
                    <td scope="row" class="text-center">
                        {{ detail.grade_name }}
                    </td>
                    <td class="text-center">
                        {{ detail.school_class.class_name_display }}
                    </td>
                    <td class="text-end">
                        {{ $helper.number(detail.account_number) }}
                    </td>
                </tr>
            </tbody>
        </table-normal>

        <alert-no-record v-else text="注文に紐付けられたライセンスはありません"></alert-no-record>

        <conclusion-row
            title="担当先生"
            :text="order.recipient_name"
            unit=""
        >
        </conclusion-row>

        <conclusion-row
            title="学校連絡先電話番号"
            :text="order.recipient_phone"
            unit=""
        >
        </conclusion-row>

        <conclusion-row
            title="希望発送日"
            :text="order.shipping_date_display"
            unit=""
        >
        </conclusion-row>

        <!-- 合計欄 -->
        <conclusion-row
            title="合計"
            :text="$helper.number(total_account_number)"
            unit="ライセンス"
        >
        </conclusion-row>
        <conclusion-row
            title="卸価"
            :text="$helper.number(order.unit_price)"
            unit="円／人"
        >
        </conclusion-row>
        <conclusion-row
            title="合計金額"
            :text="$helper.number(total_price)"
            unit="円"
        >
        </conclusion-row>
        <conclusion-row
            title="追加先生人数"
            :text="$helper.number(order.teacher_number)"
            unit="人"
        >
        </conclusion-row>
        <conclusion-row
            title="送料"
            :text="$helper.number(order.shipping_fee)"
            unit="円"
        >
        </conclusion-row>
        <text-info class="mt-3">価格は税抜です</text-info>
    </div>
</template>

<script>
import Order from '@/shared/models/entities/order';
import InlineLoader from '@/shared/components/tool/InlineLoader';
import AlertNoRecord from '@/shared/components/design/AlertNoRecord';
import PageTitle from '@/shared/components/design/PageTitle';
import SummaryBox from '@/shared/components/design/SummaryBox';
import SummaryBoxRow from '@/shared/components/design/SummaryBoxRow';
import ConclusionRow from '@/shared/components/design/ConclusionRow';
import TextInfo from '@/shared/components/design/TextInfo';
import TableNormal from '@/shared/components/design/TableNormal';
import BadgeOrderStatusForDistributor from '@/shared/components/design/BadgeOrderStatusForDistributor';
import BadgeApp from '@/shared/components/design/BadgeApp';
import BadgeYear from '@/shared/components/design/BadgeYear';

export default {
    name: 'PageOrderDetail',
    components: {
        PageTitle,
        SummaryBox,
        SummaryBoxRow,
        ConclusionRow,
        TextInfo,
        TableNormal,
        BadgeOrderStatusForDistributor,
        BadgeApp,
        BadgeYear,
        InlineLoader,
        AlertNoRecord,
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage'
    ],
    data() {
        return {
            //ローディング
            loading: true,

            //表示データ
            order: new Order(),
        }
    },
    mounted() {
        this.$http.get('/distributor/order/' + parseInt(this.$route.params.id, 10))
        .then(response => {
            this.order = new Order(response.data);
        })
        .finally(() => {
            this.loading = false;
        });
    },
    computed: {
        // ライセンス合計数を表示
        total_account_number() {
            let total = 0;
            for (let detail of this.order.details) {
                if ( !isNaN(parseInt(detail.account_number)) ) {
                    total += parseInt(detail.account_number);
                }
            }
            return this.$helper.number(total);
        },
        // 学納価合計を表示
        total_price() {
            if (this.total_account_number === null) {
                return null;
            }
            return this.total_account_number * this.order.unit_price;
        },
    },
    methods: {

    },
}
</script>

<style scoped>
</style>